"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _router = require("@reach/router");

var _Input = _interopRequireDefault(require("./Input"));

var _auth = require("../utils/auth");

var _actions = require("../actions");

var _store = require("../store");

var _routes = _interopRequireDefault(require("../routes")); // import app components


var SiteForm = function SiteForm() {
  var _ref = (0, _store.useStore)(),
      _ref2 = _slicedToArray(_ref, 2),
      config = _ref2[0].config,
      dispatch = _ref2[1];

  var _ref3 = (0, _react.useState)(''),
      _ref4 = _slicedToArray(_ref3, 2),
      title = _ref4[0],
      setTitle = _ref4[1];

  var _ref5 = (0, _react.useState)(false),
      _ref6 = _slicedToArray(_ref5, 2),
      loading = _ref6[0],
      setLoading = _ref6[1];

  var handleSubmit = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (title) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              setLoading(true);
              _context.next = 5;
              return _actions.siteActions.addSite({
                ownerID: (0, _auth.getCurrentUser)(config).sub,
                title: title
              }, dispatch, config);

            case 5:
              result = _context.sent;

              if (result) {
                (0, _router.navigate)((0, _routes.default)("dashboard", {
                  siteID: result.id
                }));
              }

              setLoading(false);
              dispatch({
                type: 'CLOSE_DIALOG'
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmit() {
      return _ref7.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical"
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "Title",
    value: title,
    onChange: function onChange(e) {
      return setTitle(e.target.value);
    },
    onKeyDown: function onKeyDown(e) {
      return e.key === 'Enter' && handleSubmit();
    }
  }), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    loading: loading,
    children: "Add",
    onClick: handleSubmit,
    type: "primary"
  }));
};

var _default = SiteForm;
exports.default = _default;